import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { apptPeriod } from "@/lib/apptPeriod";
import { CalendarPlus, CalendarDays, Inbox, Users, FileText, Receipt, Clock } from "lucide-react";

const hm = (iso) => new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
const dm = (iso) => new Date(iso).toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" });

export default function CommandCenter() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/actions").then((r) => setD(r.data)).catch(() => setD({})); }, []);
  const Tile = ({ icon: Icon, label, to, count, tone = "slate", testid }) => (
    <button type="button" onClick={() => navigate(to)} data-testid={testid}
      className={`flex items-center gap-2 rounded-xl border px-3 py-3 min-h-[52px] text-left text-sm font-medium transition-colors ${tone === "green" ? "bg-emerald-500 border-emerald-500 text-black hover:bg-emerald-600" : "bg-white border-slate-200 text-slate-800 hover:bg-slate-50"}`}>
      <Icon className="w-5 h-5 shrink-0" /><span className="flex-1 min-w-0 break-words">{label}</span>
      {count > 0 && <span className="text-[11px] font-bold rounded-full bg-red-500 text-white px-2 py-0.5">{count}</span>}
    </button>
  );
  return (
    <div className="space-y-3" data-testid="command-center">
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2">
        <Tile icon={CalendarPlus} label="Nouveau rendez-vous" to="/calendar?new=1" tone="green" testid="cc-new-appt" />
        <Tile icon={CalendarDays} label="Agenda" to="/calendar" testid="cc-calendar" />
        <Tile icon={Inbox} label="Demandes RDV" to="/requests" count={d?.requests} testid="cc-requests" />
        <Tile icon={Users} label="Clients" to="/clients" testid="cc-clients" />
        <Tile icon={FileText} label="Devis à suivre" to="/quotes" count={(d?.quotes_action || 0) + (d?.quotes_accepted || 0)} testid="cc-quotes" />
        {d?.invoices_unpaid !== undefined && <Tile icon={Receipt} label="Impayés" to="/impayes" count={d.invoices_unpaid} testid="cc-unpaid" />}
        <Tile icon={Clock} label="Aujourd'hui" to="/today" count={d?.today?.length} testid="cc-today" />
      </div>
      {d && (d.today?.length > 0 || d.upcoming?.length > 0) && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <div className="bg-white border border-slate-200 rounded-xl p-3" data-testid="cc-today-list">
            <div className="text-xs font-semibold text-slate-500 mb-1">Rendez-vous du jour ({d.today.length})</div>
            {d.today.length ? d.today.map((a) => <button key={a.id} onClick={() => navigate(`/rdv/${a.id}/atelier`)} className="w-full text-left text-sm py-1.5 flex gap-2"><b className="shrink-0">{hm(a.start)}</b><span className="truncate">{a.title || "RDV"}{a.client ? ` — ${a.client}` : ""}</span></button>) : <p className="text-sm text-slate-400">Aucun rendez-vous aujourd'hui.</p>}
          </div>
          <div className="bg-white border border-slate-200 rounded-xl p-3" data-testid="cc-upcoming-list">
            <div className="text-xs font-semibold text-slate-500 mb-1">Prochains rendez-vous</div>
            {d.upcoming.length ? d.upcoming.map((a) => <button key={a.id} data-testid={`cc-upcoming-${a.id}`} onClick={() => navigate(`/rdv/${a.id}/atelier`)} className="w-full text-left text-sm py-1.5 flex gap-2"><b className="shrink-0">{apptPeriod(a.start, a.end) || `${dm(a.start)} ${hm(a.start)}`}</b><span className="truncate">{a.title || "RDV"}{a.client ? ` — ${a.client}` : ""}</span></button>) : <p className="text-sm text-slate-400">Rien de prévu.</p>}
          </div>
        </div>
      )}
    </div>
  );
}
